import React, { Component } from 'react'
// import { Tabs } from 'antd';
import img1 from '../../../static/images/dinghuo-banner.jpg'
import product1 from '../../../static/images/product-1.png'
import product3 from '../../../static/images/product-3.png'

import advantage2 from '../../../static/images/advantage2.png'
import advantage3 from '../../../static/images/advantage3.png'
import advantage4 from '../../../static/images/advantage4.png'
import advantage5 from '../../../static/images/advantage5.png'




import './index.less';
// const { TabPane } = Tabs;
class SupplyChain extends Component {
    state = {
        iframeHeight: 600,
        customerList: [
            { img: product1, title: '安卓收银机' },
            { img: product1, title: 'PC管理后台' },
            { img: product1, title: '自主收银机' },
            { img: product1, title: '智能POS机' },
            { img: product1, title: 'APP端' },
        ],
        partnerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
    }

      componentDidMount() {
        this._onPosIframeMessage = (e) => {
            const d = e.data
            if (!d || d.source !== 'supply-iframe' || typeof d.height !== 'number') return
            if (d.height < 200) return
            this.setState({ iframeHeight: d.height })
        }
        window.addEventListener('message', this._onPosIframeMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onPosIframeMessage)
    }

    syncIframeHeightFromContent = (iframe) => {
        if (!iframe) return
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document
            const h = Math.max(
                doc.documentElement.scrollHeight,
                doc.body.scrollHeight,
                doc.documentElement.offsetHeight,
                doc.body.offsetHeight
            )
            if (h > 200) {
                this.setState({ iframeHeight: h })
            }
        } catch (err) {
            // cross-origin: rely on postMessage from pos.html
        }
    }
    onEvents() { }
    render() {
        // const { customerList, partnerList } = this.state
        const { iframeHeight } = this.state
        return (
             <div style={{ width: '100%' }}>
                <iframe
                    title="supply-static"
                    src={`${process.env.PUBLIC_URL}/static/supply/supply.html`}
                    style={{ width: '100%', height: iframeHeight, border: 'none', display: 'block', overflow: 'hidden' }}
                    onLoad={(e) => this.syncIframeHeightFromContent(e.target)}
                />
            </div>
            // <div className="product_container unattended-container affiliate-container supply-container">
            //     <div className="top-home-carousel">
            //         <div className="banner-bg"><img className="banner-img" src={img1} alt="" /></div>
            //         <div className="mode-mark"></div>
            //         <div className="mask-top-content">
            //             <div className="content-pos">
            //                 <div className="content-left-text">
            //                     <div className="banner-top-title">悦喵供应链订货系统</div>
            //                     <div className="banner-top-tips">批发企业专属数字订货系统</div>
            //                     <div className="banner-top-tips">快速打通上下游供应链调</div>
            //                 </div>

            //             </div>

            //         </div>
            //     </div>


            //     <div className="common-block-home product-page">
            //         <div className="common-block-home-title">悦喵AI订货，企业专属的数字化订货商城</div>
            //         <div className="common-block-home-tips">悦喵AI订货是企业专属的数字化订货商城，致力于帮助中小型商贸流通企业及工贸企业提高订货商城销售额、提高人效、提高资金周转率</div>
                    
            //     </div>

            //     <div className="common-block-home advantage-common-block-home">

            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">在线接单，提高人效</div>
            //                     <div className="advantage-detail-left-tips">订货商城必须足够简单和高效才能推广开，悦喵AI订货提供搜索下单、扫码下单、常购清单等多种下单方式，简单到大叔大妈也会用的傻瓜式操作，助力企业推广客户自主下单，把下单工作转交给客户自主完成，让业务员不再辛苦代下单，更有精力开拓新客户，极大提高业务员人效。</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage2} alt="" />
            //                 </div>
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage2} alt="" />
            //                 </div>
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">在线营销、提高销售额</div>
            //                     <div className="advantage-detail-left-tips">悦喵AI支持各种客户营销场景，如用直播/优惠券召回流失客户、积分/返利鼓励客户长期订货、满赠/满减提高客单价、组合促销/套餐商品来推新品或清库存等。还可通过手机短信/微信消息/推送提醒等方式，将营销活动推向客户。企业通过营销活动，培养长期订货客户，提高线上销售额。</div>
            //                 </div>
                            
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">单钱自动关联，加速资金周转</div>
            //                     <div className="advantage-detail-left-tips">对账难、回款慢、坏账多是企业最担心的问题。悦喵AI支持企业基于客户类型和交易数据，对不同客户设置不同账期/信用额度/收款方式，实现差异化收款；支持扫码收款、银行转账自动核销、批量收款等线上线下多种收款方式，实现单钱自动关联；系统预警员工/客户欠款情况，自动向客户催款。最终帮企业提高人效，减少赊账坏账，加速资金周转！</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage3} alt="" />
            //                 </div>
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style4" src={advantage4} alt="" />
            //                 </div>
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">内外协同、提高供应链效率</div>
            //                     <div className="advantage-detail-left-tips">除了外部协同所需的专业订货商城，悦喵AI订货还自带了基础的进销存，CRM、资金功能，满足企业日常所需。若企业需要更专业的ERP做内部管控，悦喵订货还提供了非常丰富的接口，能与市场主流ERP软件实时对接，实现内外业务协同，提高供应链效率</div>
            //                 </div>
                            
                           
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">会员标签</div>
            //                     <div className="advantage-detail-left-tips">多维度标签给会员多角度贴标签，基本信息及消费习惯等多维度监控为针对性营销提供信息依据</div>
            //                     <div className="advantage-detail-left-tips">精准营销，会员流失少，全方位的营销筛选条件，可根据卡券余额、购买习惯、购买频次、购买历史、生日信息等筛选营销对象。</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage5} alt="" />
            //                 </div>
            //             </div>
            //         </div>

            //     </div>


            // </div >
        )
    }
}


export default SupplyChain